import { useCallback, useEffect, useState } from 'react';

import type { TBreakPointTypes } from './hook-useMediaQuery.interface';
import { useWindowSize } from './hook-windowSize';

export function useMediaQuery(breakpoint: TBreakPointTypes): boolean {
  const { width } = useWindowSize();

  const getInitialValue = (): boolean => {
    switch (breakpoint) {
      case 'xs':
        return width < 414;
      case 'sm':
        return width < 640;
      case 'md':
        return width < 768;
      case 'sfcc-tablet':
        return width < 992;
      case 'lg':
        return width < 1024;
      default:
        return width < 1280;
    }
  };

  const [value, setValue] = useState<boolean>(getInitialValue);

  const matchBreakpoint = useCallback(() => {
    switch (breakpoint) {
      case 'xs': {
        return setValue(width < 414);
      }
      case 'sm': {
        return setValue(width < 640);
      }
      case 'md': {
        return setValue(width < 768);
      }
      case 'sfcc-tablet': {
        return setValue(width < 992);
      }
      case 'lg': {
        return setValue(width < 1024);
      }
      default: {
        return setValue(width < 1280);
      }
    }
  }, [width, breakpoint]);
  useEffect(() => {
    return matchBreakpoint();
  }, [matchBreakpoint]);
  return value;
}
